const randomString = (length = 5) => {
    return Math.random().toString(36).slice(-length)
}

export { randomString }
